import { render, staticRenderFns } from "./BaseBottomTabs.vue?vue&type=template&id=7392c483"
import script from "./BaseBottomTabs.vue?vue&type=script&lang=js"
export * from "./BaseBottomTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseBottomTabs.vue?vue&type=style&index=0&id=7392c483&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports